import { useCallback } from 'react'
import { Column, GridApi } from 'ag-grid-community'
import { intl } from '../../../../../i18n'
import MultiSelectDialog, {
  MultiSelectDialogSelection,
} from '../../../../components/dialogs/MultiSelectDialog'

type Props = {
  onClose: () => void
  onSubmit: (colIds: string[]) => void
  gridApi?: GridApi | null
}

export const ExcelExportDialog = ({ onClose, onSubmit, gridApi }: Props) => {
  const getSelectionList = useCallback(
    (gridApi?: GridApi): MultiSelectDialogSelection[] => {
      return (gridApi?.getColumns() || [])
        .filter(
          (column: Column) =>
            ![
              'uuid',
              'drag',
              'action',
              'deliverableAttachmentSummary',
            ].includes(column.getColId())
        )
        .map((column: Column) => {
          return {
            value: column.getColId(),
            displayName: gridApi?.getDisplayNameForColumn(column, null),
            defaultChecked:
              column.isVisible() ||
              column.getColDef().cellRendererParams?.uiMeta?.tree ||
              [
                'wbsItem.code',
                'wbsItem.ticketType',
                'wbsItem.displayName',
                'ticketList',
              ].includes(column.getColId()),
          }
        }) as MultiSelectDialogSelection[]
    },
    []
  )

  return (
    <MultiSelectDialog
      onClose={onClose}
      onSubmit={(allList, selectedItem) => {
        const selectedColIds = selectedItem.map(col => col.value)
        onSubmit(selectedColIds)
      }}
      dialogTitle={intl.formatMessage({
        id: 'dialog.exceloutput.columnselect.title',
      })}
      submitButtonTitle={intl.formatMessage({
        id: 'dialog.exceloutput.submit',
      })}
      allCheckBoxLabel={intl.formatMessage({
        id: 'dialog.exceloutput.columnselect.allcheckboxlabel',
      })}
      getSelectList={() => getSelectionList(gridApi ?? undefined)}
      hideIcon={true}
    />
  )
}
